<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  value: { type: [Boolean, Number, String], default: null },
});

const { t } = useI18n();
const normalizedValue = computed(() => {
  if ([true, 1, '1'].includes(props.value)) return 1;
  if ([false, 0, '0'].includes(props.value)) return 0;

  return null;
});
const label = computed(() => {
  if (normalizedValue.value === 1) return t('NUCLEO_WORK_ORDERS.TABLE.YES');
  if (normalizedValue.value === 0) return t('NUCLEO_WORK_ORDERS.TABLE.NO');

  return t('NUCLEO_WORK_ORDERS.TABLE.NOT_INFORMED');
});
const classes = computed(() => {
  if (normalizedValue.value === 1) return 'bg-green-50 text-green-700';
  if (normalizedValue.value === 0) return 'bg-red-50 text-red-700';

  return 'bg-lais-bg-soft text-lais-text-muted';
});
</script>

<template>
  <span
    class="inline-flex rounded-full px-2.5 py-1 text-xs font-semibold"
    :class="classes"
  >
    {{ label }}
  </span>
</template>
